import { render, staticRenderFns } from "./RebrandPopUp.vue?vue&type=template&id=1d24021e&scoped=true"
import script from "./RebrandPopUp.vue?vue&type=script&lang=js"
export * from "./RebrandPopUp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d24021e",
  null
  
)

export default component.exports